import { StylesConfig } from "react-select";


const customStyleSelectCards = <T extends { label: string; value: string }>(): StylesConfig<T, false> => ({
  control: (provided) => ({
    ...provided,
    backgroundColor: "#F9F9F9",
    border: "none",
    boxShadow: "none",
    minHeight: "28px", 
    height: "28px", 
    display: "flex",
    alignItems: "center",
    "&:hover": {
      border: "none",
    },
  }),
  input: (provided) => ({
    ...provided,
    color: "#4B5563",
    fontSize: "0.875rem",
    margin: "0",
    padding: "0",
    height: "28px",
    lineHeight: "26px",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#4B5563",
    fontStyle: "italic",
    fontWeight: "normal",
    lineHeight: "26px",
    paddingTop: "1px",
    margin: "0",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "28px",
    padding: "0 8px",
    display: "flex",
    alignItems: "center",
  }),
  singleValue: (provided) => ({
    ...provided,
    margin: "0",
    lineHeight: "26px",
    paddingTop: "1px",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "28px",
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: "2px",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "2px",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#FEF3C7" : "#F3F4F6",
    color: "#4B5563",
    fontSize: "0.875rem",
    padding: "4px 8px",
    "&:hover": {
      backgroundColor: "#FECACA",
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
});

export {
  customStyleSelectCards,
}
